import { useEffect } from "react";
import "../styles/Contents.css";

export default function PrivacyPolicy() {
  useEffect(() => {
    const elements = document.querySelectorAll(
      ".reveal, .reveal-left, .reveal-right"
    );

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("active");
          } else {
            entry.target.classList.remove("active");
          }
        });
      },
      { threshold: 0.15 }
    );

    elements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <div className="page">
      {/* HERO */}
      <section className="about-hero reveal">
        <h1>Privacy Policy</h1>
        <p>
          Your privacy is important to us. This policy explains how we collect,
          use, and protect your personal information.
        </p>
      </section>

      {/* CONTENT */}
      <section className="about-sectio reveal-left">
        <h2>1. Information We Collect</h2>
        <p>
          We may collect personal details such as name, phone number, email
          address, and academic details when you register, enquire, or contact
          us through our website.
        </p>
      </section>

      <section className="about-sectio reveal-right">
        <h2>2. How We Use Your Information</h2>
        <p>
          The collected information is used to provide educational services,
          respond to enquiries, improve our offerings, and communicate important
          updates related to courses and admissions.
        </p>
      </section>

      <section className="about-sectio reveal-left">
        <h2>3. Data Protection</h2>
        <p>
          We implement appropriate security measures to protect your personal
          information against unauthorized access, alteration, disclosure, or
          destruction.
        </p>
      </section>

      <section className="about-sectio reveal-right">
        <h2>4. Cookies</h2>
        <p>
          Our website may use cookies to enhance user experience and analyze
          website traffic. You can choose to disable cookies through your
          browser settings.
        </p>
      </section>

      <section className="about-sectio reveal-left">
        <h2>5. Third-Party Services</h2>
        <p>
          We do not sell or share your personal information with third parties
          except where required by law or to provide essential services.
        </p>
      </section>

      <section className="about-sectio reveal-right">
        <h2>6. Updates to This Policy</h2>
        <p>
          This privacy policy may be updated periodically. Any changes will be
          reflected on this page.
        </p>
      </section>

      {/* FOOTER NOTE */}
      <section className="about-footer reveal">
        <p>
          If you have any questions regarding this Privacy Policy, please
          contact us directly. We are committed to protecting your privacy.
        </p>
      </section>
    </div>
  );
}
